module.exports = __webpack_public_path__ + "static/media/arrow-horizontal.4b210548.svg";